import * as React from 'react'
import {Text, TYPOGRAPHY} from 'wix-ui-tpa/Text'
import s from './page-title.st.css'

export const PageTitle = props => <Text typography={TYPOGRAPHY.largeTitle} {...props} className={s.root} />
